import { SocialMediaQuality } from '@/classes/SocialMediaQuality'
import { StreamUrl } from '@/classes/streamurl'
import { srtInputLine, srtOutputLine } from '@/helpers/statusHelper'
import { Stream, StreamProtocol, StreamType } from '@/types/streams'
import { computed, ComputedRef } from '@vue/composition-api'
import useTeamStreams from './teamstreams'

const useStreamInfo = (streamId: ComputedRef<string|null>) => {
  const teamStreams = useTeamStreams()
  const stream: ComputedRef<Stream|null> = computed(() => {
    if (streamId.value === null) return null
    return teamStreams.streams.value[streamId.value] ?? null
  })

  const isOutput = computed(() => stream.value?.type === StreamType.Output)

  const sourceUrl = computed(() => {
    if (stream.value?.variants?.original !== undefined) {
      return stream.value?.auth_info?.ingest_url ?? stream.value.variants.original.url
    }
    if (stream.value?.srcurl !== undefined && !isOutput.value) {
      return stream.value?.auth_info?.ingest_url ?? stream.value?.srcurl
    }
    return stream.value?.url ?? stream.value?.srcurl ?? ''
  })

  const streamUrlObj = computed(() => new StreamUrl(sourceUrl.value))

  const streamUrl = computed(() =>{
    if (stream.value?.protocol === StreamProtocol.Srt || nimbleSrtUrl.value) {
      return nimbleSrtUrl.value
    } else {
      return streamUrlObj.value.streamurl ?? ''
    }
  })

  const streamKey = computed(() => {
    if (isNimbleSrt.value) return ''
    return streamUrlObj.value.streamkey ?? ''
  })

  const socialMedia = computed(() => {
    if (!isOutput.value) return ''
    return SocialMediaQuality.getSocialMedia(sourceUrl.value)
  })

  const bitrate = computed(() => {
    if (isOutput.value && stream.value?.rate?.video_bitrate !== undefined) {
      return stream.value.rate.video_bitrate / 1000
    }
    return 0
  })

  const nimbleSrtUrl = computed(() => stream.value?.nimble_stream_url ?? '')
  const isNimbleSrt = computed(() => nimbleSrtUrl.value !== '')
  const srtInfo = computed(() => {
    if (stream.value === null) return ''
    if (isOutput.value) return srtOutputLine(stream.value)
    else return srtInputLine(stream.value)
  })

  return {
    bitrate,
    isNimbleSrt,
    // isOutput,
    name: computed(() => stream.value?.name ?? ''),
    socialMedia,
    sourceUrl,
    srtInfo,
    stream,
    streamKey,
    streamUrl
  }
}

export default useStreamInfo
